import store from "@/store"
import masterRoute from './dashboard/masterRoute'
import userRoute from './dashboard/userRoute'
import landingRoute from './dashboard/landingRoute'
function loadDashboard(view) {
    return () => import( /* webpackChunkName: "dashboard-[request]" */ `@/components/dashboard/${view}.vue`)
}

const dashboardRoute = [
    {
        path: '',
        name: 'Dashboard',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadDashboard('main'),
    },
    {
        path: 'event-history',
        name: 'EventHistory',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['prhn']
        },
        component: loadDashboard('EventHistory'),
    },
    {
        path: 'event-data',
        name: 'EventData',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['superadmin','bkak']
        },
        component: loadDashboard('eventData'),
    },
    {
      path: 'job-vacancy',
      name: 'Event History Detail',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: ['prhn','superadmin','bkak']
      },
      component: loadDashboard('eventMaster'),
    },
    {
      path: 'event/job-vacancy',
      name: 'Add JobVacancy',
      meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['prhn','kprhn']
      },
      component: loadDashboard('JobVacancyForm'),
    },
    {
      path: 'event/job-vacancy/:id',
      name: 'Edit JobVacancy',
      meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
      },
      component: loadDashboard('JobVacancyForm'),
    },
    {
        path: 'company-profile',
        name: 'CompanyProfile',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['prhn','kprhn']
        },
        component: loadDashboard('companyProfile'),
    },
    {
        path: 'user-account',
        name: 'Profile Dashboard',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadDashboard('profile'),
    },
    {
        path: 'change-password',
        name: 'Change Password',
        meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
        },
        component: loadDashboard('passwordSetting'),
    },
    ...masterRoute,
    ...userRoute,
    ...landingRoute
]
const routerFilter = async () => {
  await store.restored;
  const myrole = store.getters["auth/getRole"];
  const isLoggedIn = store.getters['getisLoggedIn']
  return dashboardRoute.filter((row) => {
    return (row.meta.requiresAuth == isLoggedIn && ((row.meta.roleVerif && row.meta.role.some(role => role == myrole) || !row.meta.roleVerif))) || !row.meta.requiresAuth
  })
}
export default routerFilter()